import React from 'react';
import styles from './styles.module.scss';

const TeamBackground = () => <div className={styles.teamsBackground}></div>;

export default TeamBackground;
